import {useEffect, useState} from "react";
import Titlebar from "@civicplus/preamble/lib/Titlebar";
import SearchInput from "@civicplus/preamble/lib/SearchInput";
import StickyRightBar from "@civicplus/preamble/lib/StickyRightBar";
import List from "@civicplus/preamble/lib/List";
import Typography from "@civicplus/preamble/lib/Typography";
import WorkIcon from "@material-ui/icons/Work";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import Avatar from "@civicplus/preamble/lib/Avatar";
import {Col, Row, Container} from "react-bootstrap";
import ContentList from "@civicplus/preamble-ui-hcms/lib/ContentList/ContentList";
import { ContentTypesApi } from "@civicplus/hcms-api-sdk/dist/sdk";
//import goldTrophyImage from ".../common/img/trophyGold.png";
 
 

const headerStyle = {
    display: "flex",
    alignItems: "center",
};

const config = {
	appName: "ares",
	baseUrl: "https://content-qa.civicplus.com",
	clientId: "robert",
	clientSecret: "MffJ76JZe1C00G9z5lAKAI5jOD4ThHYnH8z4nqKorWE="
};
config.headers = { ...config.headers, "X-ResolveFlow": "true" };

const UITest = () => {
	const [id, setId] = useState();
	const [version, setVersion] = useState(0);
	const [contentTypes, setContentTypes] = useState([]);
	const [selectedContentType, setSelectedContentType] = useState({ label: "article", value: "article" });
	const [showUnpublished, setShowUnpublished] = useState(false);

	useEffect(() => {
		const fetchContentTypes = async () => {
		const schemaApi = new ContentTypesApi(config);
		const schemas = await schemaApi.getContentTypes(config.appName);
		setContentTypes(schemas.items);
		};
  
		fetchContentTypes();
	 }, []);
 
     const [searchValue, setSearchValue] = useState("");
     const [checkedObject, setCheckedObject] = useState({
        cb1: false,
        cb2: false
    });

    const onChange = (event, checked) => {
        setCheckedObject({
            ...checkedObject,
            [event.target.id]: checked
        });
    };

    const onSearch = event => {
        alert(`Search term: ${searchValue}`);
    };
       
	const [refReturn, setRefReturn] = useState();

        return (
        <div>
            <Titlebar title="UI Test Page" breadcrumbs={[<div key="UITestPage">UITestPage</div>]} />
            <div style={{ padding: "0 1rem", marginBottom: "1rem", border: "2px solid #000", borderColor: "#fff", backgroundColor: "#CBB384"}}>
					<Row id="communityVoiceHeaderBox">
					<Col lg={8}>
					<Typography variant="h5" id="toolbarTitle" gutterBottom={true}>Community Voice</Typography>
					<Typography variant="caption" id="toolbarTitle" gutterBottom={true} noWrap={true}>This module is a great weigh to get involved in your Community. You should TRY IT.</Typography>
					</Col>
					<Col lg={4}>
					<div style={{ margin: "10px" }}>
                        <SearchInput
                            id="search-input"
                            onChange={onChange}
                            onSearch={onSearch}
                            placeholder="Search for stuff"
                            value={searchValue}
                            margin={false}
                        />
                    </div>
					</Col>
					</Row>
            </div>;
			<Row>
			<Col lg={9}>
			<Container id="contentContainer" style={{ padding: "0 1rem", marginBottom: "1rem", border: "2px solid #000", borderColor: "#fff", backgroundColor: "#E5CC9C"}}>
				<Typography variant="h5" id="toolbarTitle" gutterBottom={true}>Bikes are Fun!</Typography>
				<div style={{ margin: "10px" }}>
							<SearchInput
								id="search-input"
								onChange={onChange}
								onSearch={onSearch}
								placeholder="What's your idea?"
								value={searchValue}
								margin={false}
							/>
						</div>
						   
            <ContentList
				id="contentListGeneral"
				key={`${version}:${id}`}
				config={config}
				schema={"qatesting"}
				header={"General Content List"}
				subheader={"Displays alerts for content list callbacks."}
				addContentButton={{ onClick: () => alert("Add content!"), text: "Add Content!" }}
				onRowClick={(item) => {
				setImmediate(item.id);
				}}
				onRef={setRefReturn}
				getSortProperty={"title"}
				pagination={{
				rowsPerPage: 5,
				rowsPerPageOptions: [5, 10, 25, 50, 100],
				}}
				enablePreload={true}
				includeUnpublished={false}
				selectableRows={"multiple"}
				contentId={id}
				onBuildColumn={(field) => {
					return {
					   name: "ideaColumn",
					   label: "Ideas",
					   key: "ideaColumn",
					};
				 }}
				 onBuildRow={(data) => <div>{data.id}</div>}
				
			// actions={actions}
		  />
			</Container>
			</Col>
			<Col lg={1}>
            <StickyRightBar
				id="stickyRightBar-demo"
				rightBar={
					<div style={{ width: "250px", backgroundColor: "#008080", padding: "1rem", color: "#fff" }}>
						<Typography style={{textDecoration: "underline", textDecorationColor: "#fff", fontSize: "1.5em", paddingLeft: "1.5em" }} variant="subtitle1" gutterBottom={true}>
								Faetured Ideas
							</Typography>
						<div style={{ padding: "0 1rem", marginBottom: "1rem", border: "2px solid #000", borderColor: "#fff" }}>
							<div style={{borderBottom: "1px solid #000", borderColor: "#fff"}}>
								Add a bike lane to Anderson/Bluemont
							</div>
							<br/> 
							<div>
								Sep 23, 2011 by First Last <br/>
								(10,000 points)
							</div>
							<br/> 
							<div>
							Lorem ipsum dolor sit amet, eum eu utinam graece epicuri, vel ad viris viderer. Id vivendo sententiae complectitur duo, ne est mucius definitiones. 
							Nonumy populo iriure mei te. Te quando diceret petentium quo.
							</div>
							
						</div>
						
						<div>
							<h3 style={{color: "#fff", paddingLeft: "2em", borderTop: "1px solid #fff", paddingTop: "10px"}}>Topics</h3>
							<ul style={{borderBottom: "1px solid #fff", paddingBottom: "10px"}}>
								<li>Topic Name Here</li>
								<li>Topic Name Here</li>
								<li>Topic Name Here</li>
								<li>Topic Name Here</li>
								<li>Topic Name Here</li>
								<li>Topic Name Here</li>
							</ul>
						</div>
						<div>
							<h3 style={{color: "#fff", paddingLeft: "2em", paddingTop: "10px"}}>Leaderboard</h3>
							<List
								id="demo-avatar"
								aria-label="Example List"
								listItems={[
									{ itemAvatar: <Avatar id="firstPlaceTrophy" name="FirstPlaceName" src="" /> , itemText: { primary: "FirstName LastName", secondary: "10,000,000,001 points" } },
									{ itemAvatar: <WorkIcon />, itemText: { primary: "FirstName LastName", secondary: "1,000,000,001 points" } },
									{ itemAvatar: <BeachAccessIcon />, itemText: { primary: "FirstName LastName", secondary: "500,000,001 points" } }
								]}
							/>


						</div>

					</div>
				}>
		</StickyRightBar>
		</Col>
		</Row>
        </div>
    );
};

export default UITest;
